import type { ButtonProps } from "@mantine/core";
import { Button } from "@mantine/core";
import type { ComponentProps } from "react";

type MarkDoneActionButtonProps = ButtonProps & ComponentProps<"button">;

function MarkDoneActionButton({
  children = "Als erledigt markieren",
  ...rest
}: MarkDoneActionButtonProps) {
  return (
    <Button mt="xs" w="100%" {...rest}>
      {children}
    </Button>
  );
}

export { MarkDoneActionButton, type MarkDoneActionButtonProps };
